webpackJsonp([52],{

/***/ "09yM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "13kN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-114a9e2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/loading/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("T0IC")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_loading,
  src_components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var _vux_2_9_4_vux_src_components_loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "33rv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4a+h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var components_inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-0f36864e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/inline-desc/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vux-label-desc"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_inline_desc = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/inline-desc/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("MBCp")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_inline_desc,
  src_components_inline_desc,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var _vux_2_9_4_vux_src_components_inline_desc = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8Ygm":
/***/ (function(module, exports) {

var Func = function () {
  function add0(m) {
    return m < 10 ? '0' + m : m;
  }
  var formFormat = function formFormat(format) {
    if (String(format).length > 15) {
      return format;
    }
    if (!format) {
      var d = new Date();
    } else {
      var d = new Date(format * 1000); //根据时间戳生成的时间对象
    }

    var date = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + " " + d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
    return date;
  };
  var formFormatTime = function formFormatTime(format) {
    var times = '';
    var hours = '';
    if (String(format).length > 15) {
      var d = new Date(format); //根据时间戳生成的时间对象
      times = d.getMonth() + 1 + "-" + d.getDate();
      hours = d.getHours() + ":" + (d.getMinutes().toString().length === 2 ? d.getMinutes() : '0' + d.getMinutes());
      return {
        times: times,
        hours: hours
      };
    }
    var d = new Date(format * 1000); //根据时间戳生成的时间对象
    times = d.getMonth() + 1 + "-" + d.getDate();
    hours = d.getHours() + ":" + (d.getMinutes().toString().length === 2 ? d.getMinutes() : '0' + d.getMinutes());
    return {
      times: times,
      hours: hours
    };
  };
  var formatTimeSecond = function formatTimeSecond(shijianchuo) {
    //shijianchuo是整数，否则要parseInt转换
    if (shijianchuo.toString().length == 10) {
      shijianchuo = shijianchuo * 1000;
    }
    var time = new Date(shijianchuo - 0);
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();
    var h = time.getHours();
    var mm = time.getMinutes();
    var s = time.getSeconds();

    return (/*y + '-' + add0(m) + '-' + add0(d) + ' ' + */add0(h) + ':' + add0(mm) + ':' + add0(s)
    );
  };

  var getCode = function getCode() {
    //获取当前时间
    var date = new Date();
    var seperator1 = "-";
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    return new Array(year, month, strDate).join('');
  };
  /**
   * randomWord 产生任意长度随机字母数字组合
   * randomFlag-是否任意长度 min-任意长度最小位[固定位数] max-任意长度最大位
   * 用法  randomWord(false,6);规定位数 flash
   *      randomWord(true,3，6);长度不定，true
   * arr变量可以把其他字符加入，如以后需要小写字母，直接加入即可
   */
  var randomWord = function randomWord(randomFlag, min, max) {

    var str = "",
        range = min,
        arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
    // 随机产生
    if (randomFlag) {
      range = Math.round(Math.random() * (max - min)) + min;
    }
    for (var i = 0; i < range; i++) {
      var pos = Math.round(Math.random() * (arr.length - 1));
      str += arr[pos];
    }
    return str;
  };

  return {
    formFormat: formFormat,
    formFormatTime: formFormatTime,
    formatTimeSecond: formatTimeSecond,
    randomWord: randomWord,
    getCode: getCode
  };
}();
module.exports = Func;

/***/ }),

/***/ "DMSW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GRuq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var components_icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-dc7dd078","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/icon/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[_vm.className, _vm.isMsg ? 'weui-icon_msg' : '']})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_icon = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/icon/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("VSKm")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_icon,
  src_components_icon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var _vux_2_9_4_vux_src_components_icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HCAt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("kV13");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("48sp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persist__ = __webpack_require__("ZPhf");




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    recordStatus: 0,
    loadingStatus: 0,
    searchHistoryList: [], //收缩历史记录
    userInfo: null, //用户信息
    goodsInfo: null, //商品信息
    goodsInfoList: null, //商品信息列表
    addressList: [], // 省市区地址列表
    selectGoodsInfo: [], // 省市区地址列表
    selectCardId: [], // 选择的购物车商品Id
    shoppingAddress: {
      selectAddress: null,
      addressType: 'default', // 默认地址
      defaultAddress: null
    } //  收货地址
  },
  mutations: {
    updateRecordStatus: function updateRecordStatus(state, payload) {
      state.recordStatus = payload.recordStatus;
    },
    updateSearchHistoryList: function updateSearchHistoryList(state, payload) {
      state.searchHistoryList = payload.searchHistoryList;
    },
    updateLoadingStatus: function updateLoadingStatus(state, payload) {
      state.loadingStatus = payload.loadingStatus;
    },
    updateUserInfo: function updateUserInfo(state, payload) {
      state.userInfo = payload.userInfo;
    },
    updateAddressList: function updateAddressList(state, payload) {
      state.addressList = payload.addressList;
    },
    updateShoppingAddress: function updateShoppingAddress(state, payload) {
      console.log(payload);
      if (payload.type === 'shoppingAddress') {
        state.shoppingAddress.selectAddress = payload.shoppingAddress;
        state.shoppingAddress.addressType = 'select';
      } else if (payload.type === 'defaultAddress') {
        state.shoppingAddress.defaultAddress = payload.defaultAddress ? payload.defaultAddress : state.shoppingAddress.defaultAddress;
        state.shoppingAddress.addressType = 'default';
      } else if (payload.type === 'update') {
        state.shoppingAddress.defaultAddress = payload.defaultAddress;
      }
    },
    updateSelectGoodsInfo: function updateSelectGoodsInfo(state, payload) {
      state.selectGoodsInfo = payload.selectGoodsInfo;
    },
    updateGoodsInfo: function updateGoodsInfo(state, payload) {
      state.goodsInfo = payload.goodsInfo;
    },
    updateGoodsInfoList: function updateGoodsInfoList(state, payload) {
      state.goodsInfoList = payload.goodsInfoList;
    },
    updateSelectCardId: function updateSelectCardId(state, payload) {
      state.selectCardId = payload.selectCardId;
    }
  },
  plugins: [new __WEBPACK_IMPORTED_MODULE_2_vuex_persist__["a" /* default */]({
    reducer: function reducer(state) {
      return {
        userInfo: state.userInfo, //这个就是存入localStorage的值
        goodsInfo: state.goodsInfo, //这个就是存入localStorage的值
        selectCardId: state.selectCardId,
        goodsInfoList: state.goodsInfoList,
        searchHistoryList: state.searchHistoryList
      };
    },
    storage: window.localStorage
  }).plugin]
}); // 这里你可能已经有其他 module

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "Jtfc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LulU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MBCp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MdGl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/_vue@2.6.11@vue/dist/vue.esm.js
var vue_esm = __webpack_require__("kV13");

// EXTERNAL MODULE: ./src/lib/utils/system.extended.js
var system_extended = __webpack_require__("n0LP");
var system_extended_default = /*#__PURE__*/__webpack_require__.n(system_extended);

// EXTERNAL MODULE: ./node_modules/_lib-flexible@0.3.2@lib-flexible/flexible.js
var flexible = __webpack_require__("D0oh");
var flexible_default = /*#__PURE__*/__webpack_require__.n(flexible);

// EXTERNAL MODULE: ./src/api/func.js
var func = __webpack_require__("8Ygm");
var func_default = /*#__PURE__*/__webpack_require__.n(func);

// EXTERNAL MODULE: ./node_modules/_fastclick@1.0.6@fastclick/lib/fastclick.js
var fastclick = __webpack_require__("iDdd");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// EXTERNAL MODULE: ./node_modules/_vue-router@3.1.5@vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("p7sN");

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("a3Yh");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./src/api/comm/index.js
var comm = __webpack_require__("xfkp");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/App.vue


var _name$data$computed$m;

//
//
//
//
//
//
//
//
//

function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]).replace(/\//g, '');return null;
}

/* harmony default export */ var App = (_name$data$computed$m = {
  name: 'app',
  data: function data() {
    return {
      showUpdate: false,
      transitionName: '',
      cityList: []
    };
  },

  computed: {},
  mounted: function mounted() {},
  beforeCreate: function beforeCreate() {},
  created: function created() {
    this.getAddressList();
  }
}, defineProperty_default()(_name$data$computed$m, "mounted", function mounted() {}), defineProperty_default()(_name$data$computed$m, "methods", {
  /**
   * "name": "门头沟区",
   * "value": "110109",
   * "parent": "110100"
   * */
  initData: function initData(data) {
    var _this = this;

    if (data.length) {
      data.map(function (item, index) {
        if (item.name !== '国外') {
          _this.cityList.push({
            name: item.name,
            value: item.id + '',
            parent: item.province_id ? item.province_id + '' : item.city_id ? item.city_id + '' : 0
          });
        }
        if (item.children && !item.children.length) {
          _this.initData([{
            name: '',
            value: '',
            city_id: item.id
          }]);
        }
        if (item.children && item.children.length) {
          _this.initData(item.children);
        }
      });
    }
    return this.cityList;
  },
  getAddressList: function getAddressList() {
    var _this2 = this;

    Object(comm["L" /* findDistrict */])().then(function (res) {
      _this2.cityList = [];
      _this2.$store.commit('updateAddressList', { addressList: _this2.initData(res.data, _this2.cityList) });
    });
  }
}), defineProperty_default()(_name$data$computed$m, "components", {}), defineProperty_default()(_name$data$computed$m, "watch", {
  '$route': function $route(to, from) {

    // var noTranstionRouter = ['/', '/message', '/my'];
    // if(noTranstionRouter.indexOf(to.path) > -1 && noTranstionRouter.indexOf(from.path)>-1){
    //     this.transitionName = 'aaa';
    //     return;
    // }
    // const toDepth = to.path.split('/').length
    // const fromDepth = from.path.split('/').length
    // if(toDepth === fromDepth){
    //       this.transitionName = 'slide-right'
    // }else{
    //    this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
    // }
  }
}), _name$data$computed$m);
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/App.vue


var App__name$data$computed$m;

//
//
//
//
//
//
//
//
//

function App_getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]).replace(/\//g, '');return null;
}

/* harmony default export */ var selectortype_script_index_0_src_App = (App__name$data$computed$m = {
  name: 'app',
  data: function data() {
    return {
      showUpdate: false,
      transitionName: '',
      cityList: []
    };
  },

  computed: {},
  mounted: function mounted() {},
  beforeCreate: function beforeCreate() {},
  created: function created() {
    this.getAddressList();
  }
}, defineProperty_default()(App__name$data$computed$m, "mounted", function mounted() {}), defineProperty_default()(App__name$data$computed$m, "methods", {
  /**
   * "name": "门头沟区",
   * "value": "110109",
   * "parent": "110100"
   * */
  initData: function initData(data) {
    var _this = this;

    if (data.length) {
      data.map(function (item, index) {
        if (item.name !== '国外') {
          _this.cityList.push({
            name: item.name,
            value: item.id + '',
            parent: item.province_id ? item.province_id + '' : item.city_id ? item.city_id + '' : 0
          });
        }
        if (item.children && !item.children.length) {
          _this.initData([{
            name: '',
            value: '',
            city_id: item.id
          }]);
        }
        if (item.children && item.children.length) {
          _this.initData(item.children);
        }
      });
    }
    return this.cityList;
  },
  getAddressList: function getAddressList() {
    var _this2 = this;

    Object(comm["L" /* findDistrict */])().then(function (res) {
      _this2.cityList = [];
      _this2.$store.commit('updateAddressList', { addressList: _this2.initData(res.data, _this2.cityList) });
    });
  }
}), defineProperty_default()(App__name$data$computed$m, "components", {}), defineProperty_default()(App__name$data$computed$m, "watch", {
  '$route': function $route(to, from) {

    // var noTranstionRouter = ['/', '/message', '/my'];
    // if(noTranstionRouter.indexOf(to.path) > -1 && noTranstionRouter.indexOf(from.path)>-1){
    //     this.transitionName = 'aaa';
    //     return;
    // }
    // const toDepth = to.path.split('/').length
    // const fromDepth = from.path.split('/').length
    // if(toDepth === fromDepth){
    //       this.transitionName = 'slide-right'
    // }else{
    //    this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
    // }
  }
}), App__name$data$computed$m);
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-69f80fd4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":_vm.transitionName}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("kXXg")
  __webpack_require__("exP/")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/_vuex-router-sync@5.0.0@vuex-router-sync/index.js
var _vuex_router_sync_5_0_0_vuex_router_sync = __webpack_require__("tT0r");
var _vuex_router_sync_5_0_0_vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(_vuex_router_sync_5_0_0_vuex_router_sync);

// EXTERNAL MODULE: ./src/router/index.js + 2 modules
var router = __webpack_require__("YaEn");

// EXTERNAL MODULE: ./src/store/index.js
var store = __webpack_require__("IcnI");

// EXTERNAL MODULE: ./node_modules/_vue-clipboard2@0.1.1@vue-clipboard2/vue-clipboard.js
var vue_clipboard = __webpack_require__("2+1C");
var vue_clipboard_default = /*#__PURE__*/__webpack_require__.n(vue_clipboard);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/comm/block/index.vue
//
//
//
//
//
//

/* harmony default export */ var block = ({
  props: {
    color: {
      type: String,
      default: ''
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/comm/block/index.vue
//
//
//
//
//
//

/* harmony default export */ var comm_block = ({
  props: {
    color: {
      type: String,
      default: ''
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-7b21a593","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/comm/block/index.vue
var block_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"area-block",style:({background: _vm.color || ''})},[_vm._t("default")],2)}
var block_staticRenderFns = []
var block_esExports = { render: block_render, staticRenderFns: block_staticRenderFns }
/* harmony default export */ var components_comm_block = (block_esExports);
// CONCATENATED MODULE: ./src/components/comm/block/index.vue
function block_injectStyle (ssrContext) {
  __webpack_require__("Tnhg")
}
var block_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var block___vue_template_functional__ = false
/* styles */
var block___vue_styles__ = block_injectStyle
/* scopeId */
var block___vue_scopeId__ = "data-v-7b21a593"
/* moduleIdentifier (server only) */
var block___vue_module_identifier__ = null
var block_Component = block_normalizeComponent(
  comm_block,
  components_comm_block,
  block___vue_template_functional__,
  block___vue_styles__,
  block___vue_scopeId__,
  block___vue_module_identifier__
)

/* harmony default export */ var src_components_comm_block = (block_Component.exports);

// EXTERNAL MODULE: ./node_modules/_axios@0.18.0@axios/index.js
var _axios_0_18_0_axios = __webpack_require__("aozt");
var _axios_0_18_0_axios_default = /*#__PURE__*/__webpack_require__.n(_axios_0_18_0_axios);

// EXTERNAL MODULE: ./node_modules/_element-ui@2.13.0@element-ui/lib/element-ui.common.js
var element_ui_common = __webpack_require__("TcQY");
var element_ui_common_default = /*#__PURE__*/__webpack_require__.n(element_ui_common);

// EXTERNAL MODULE: ./node_modules/_element-ui@2.13.0@element-ui/lib/theme-chalk/index.css
var theme_chalk = __webpack_require__("09yM");
var theme_chalk_default = /*#__PURE__*/__webpack_require__.n(theme_chalk);

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/plugins/datetime/index.js
var datetime = __webpack_require__("RZkS");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/plugins/close-dialogs/index.js
var close_dialogs = __webpack_require__("/VNz");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/plugins/device/index.js
var device = __webpack_require__("Zw8+");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/plugins/toast/index.js
var toast = __webpack_require__("TdyD");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/plugins/alert/index.js + 1 modules
var plugins_alert = __webpack_require__("bpDH");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/plugins/confirm/index.js
var plugins_confirm = __webpack_require__("ZJOS");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/plugins/loading/index.js
var loading = __webpack_require__("CV5F");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/plugins/ajax/index.js
var ajax = __webpack_require__("3qb0");

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("3cXf");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("hRKE");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/promise.js
var promise = __webpack_require__("rVsN");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("aA9S");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("ZLEe");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("HzJ8");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// CONCATENATED MODULE: ./src/lib/utils/vue.extended.js






/**
 * TODO:VUE全局扩展方法
 */



/* harmony default export */ var vue_extended = ({
  install: function install(vue, options) {
    vue.prototype.$http = _axios_0_18_0_axios_default.a;
    vue.prototype.pageSize = 10;
    vue.prototype.clinicStatus = function (status) {
      switch (status) {
        case -3:
          return 'danger';
        case -2:
          return 'warning';
        case -1:
          return 'info';
        case 0:
          return '';
        case 1:
          return 'success';
        case 2:
          return 'success';
        case 3:
          return 'success';
      }
    };
    vue.prototype.askStatus = function (status) {
      switch (status) {
        case 1:
          return 'danger';
        case 2:
          return 'success';
        case 3:
          return 'info';
      }
    };
    vue.prototype.clone = function (params) {
      var arg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var item = arg;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(keys_default()(params)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          if (Array.isArray(params[key])) {
            item[key] = vue.prototype.clone(params[key], []);
          } else if (params[key] instanceof Object) {
            item[key] = assign_default()({}, params[key]);
          } else {
            item[key] = params[key];
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return item;
    };
    vue.prototype.httpToHttps = function (url) {
      if (url.indexOf('http://') > -1) {
        return url.replace(/^http:\/\//, 'https://');
      }
      return url;
    }, vue.prototype.$http.interceptors.response.use(function (response) {
      store["a" /* default */].commit('updateLoadingStatus', { isLoading: false });
      return response;

      // Do something with response data
      var resp = {};
      if (response.data.status) {
        vue.$vux.toast.show({
          text: response.data.msg,
          type: 'cancel'
        });
        if (response.data.status === -1) {
          sessionStorage.removeItem('token');
          window.location.replace('/');
        }
        resp.resp = {};
      } else {
        resp.resp = response.data.data || response.data;
      }
      store["a" /* default */].commit('updateLoadingStatus', { isLoading: false });
      return resp;
    }, function (error) {
      /*vue.$vux.toast.show({
        text: '服务器异常',
        type: 'cancel'
      })*/
      // Do something with response error
      store["a" /* default */].commit('updateLoadingStatus', { isLoading: false });
      return promise_default.a.reject(error);
    });
    vue.prototype.ageFormart = function (birthday, end) {
      var _month = 30.4368;
      var _birthday = 0;
      var now = Date.now();
      // 如果传入终止日期则用end去计算
      if (end) {
        try {
          now = new Date(end.replace(/-/g, '/')).getTime();
        } catch (e) {
          now = new Date(end).getTime();
        }
      }
      try {
        _birthday = birthday.replace(/-/g, '/');
      } catch (e) {
        _birthday = birthday;
      }
      _birthday = now - new Date(_birthday).getTime();
      var year = Math.floor(_birthday / (12 * _month * 24 * 60 * 60 * 1000));
      var month = Math.floor(_birthday % (12 * _month * 24 * 60 * 60 * 1000) / (12 * _month * 24 * 60 * 60 * 1000) * 12);
      if (year !== 0 && !year) {
        return '';
      }
      return year + '\u5C81' + month + '\u4E2A\u6708';
    };
    vue.prototype.babyAge = function (birthday, end) {
      var _month = 30.4368;
      var _birthday = 0;
      var now = Date.now();
      // 如果传入终止日期则用end去计算
      if (end) {
        try {
          now = new Date(end.replace(/-/g, '/')).getTime();
        } catch (e) {
          now = new Date(end).getTime();
        }
      }
      try {
        _birthday = birthday.replace(/-/g, '/');
      } catch (e) {
        _birthday = birthday;
      }
      _birthday = now - new Date(_birthday).getTime();
      return Math.floor(_birthday / (12 * _month * 24 * 60 * 60 * 1000));
    };
    // 本地存储封装
    /**
     * 传入参数是读写
     * @param item
     * 对象：写入操作，字符串：都操作，不传参返回清除函数接受键
     * @returns {function(*=)}
     */
    vue.prototype.storage = function (item) {
      if (item instanceof Object) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = get_iterator_default()(keys_default()(item)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var key = _step2.value;

            var _item = item[key];
            if ((typeof _item === 'undefined' ? 'undefined' : typeof_default()(_item)) === 'object') {
              _item = stringify_default()(_item);
            }
            sessionStorage.setItem(key, _item);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      } else if (item) {
        try {
          return JSON.parse(sessionStorage.getItem(item));
        } catch (e) {
          // console.warn(`${item}不是对象`)
          return sessionStorage.getItem(item);
        }
      } else {
        return function (key) {
          sessionStorage.removeItem(key);
        };
      }
    };
    vue.prototype.pickerOptionsNext = {
      disabledDate: function disabledDate(time) {
        return time.getTime() <= Date.now();
      }
    };
    vue.prototype.pickerOptionsFast = {
      disabledDate: function disabledDate(time) {
        return time.getTime() > Date.now();
      },

      shortcuts: [{
        text: '今天',
        onClick: function onClick(picker) {
          picker.$emit('pick', new Date());
        }
      }, {
        text: '昨天',
        onClick: function onClick(picker) {
          var date = new Date();
          date.setTime(date.getTime() - 3600 * 1000 * 24);
          picker.$emit('pick', date);
        }
      }, {
        text: '一周前',
        onClick: function onClick(picker) {
          var date = new Date();
          date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit('pick', date);
        }
      }]
    };
    vue.prototype.updatePage = function (self, pageNo) {
      var route = assign_default()({}, self.$route);
      var p = assign_default()(route, {
        query: {
          pageNo: pageNo
        }
      });
      self.$router.replace(p);
    };
    vue.prototype.getPageNo = function (self) {
      return Number(self.$route.query.pageNo) || 1;
    };
    /**
     * 验证
     * @param self
     * this
     * @returns {string}
     * 返回验证信息，如果验证不通过则返回错误信息，验证通过则返回空串
     */
    vue.prototype.validate = function (self) {
      var error = '';

      var _loop = function _loop(key) {
        var obj = self.rules[key];
        obj.map(function (item) {
          var data = '';
          try {
            data = (self[self.formData][key] || '').replace(/\s+/g, '');
          } catch (e) {
            data = self[self.formData][key];
          }
          if (item.required && !data) {
            error = item;
          } else if (item.pattern && !item.pattern.test(data)) {
            error = item;
          }
        });
        if (error) {
          return {
            v: error
          };
        }
      };

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = get_iterator_default()(keys_default()(self.rules)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var key = _step3.value;

          var _ret = _loop(key);

          if ((typeof _ret === 'undefined' ? 'undefined' : typeof_default()(_ret)) === "object") return _ret.v;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    };

    vue.prototype.setCookie = function (name, value, days) {
      var d = new Date();
      if (!days) {
        days = 30;
      }
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
      window.document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
    };
    //获取cookie、
    vue.prototype.getCookie = function (name) {
      var arr,
          reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if (arr = document.cookie.match(reg)) return arr[2];else return null;
    };

    //删除cookie
    vue.prototype.delCookie = function (name) {
      var d = new Date();
      d.setTime(d.getTime() + -10 * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toGMTString();
      document.cookie = name + "=" + '' + ";path=/;" + expires;
    };
  }
});
// EXTERNAL MODULE: ./src/lib/utils/rem.device.js
var rem_device = __webpack_require__("u8ew");
var rem_device_default = /*#__PURE__*/__webpack_require__.n(rem_device);

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/directives/transfer-dom/index.js
var transfer_dom = __webpack_require__("uiKT");

// EXTERNAL MODULE: ./node_modules/_vue-ydui@1.2.6@vue-ydui/dist/lib.rem/slider/index.js
var slider = __webpack_require__("ID/j");
var slider_default = /*#__PURE__*/__webpack_require__.n(slider);

// EXTERNAL MODULE: ./node_modules/_vue-ydui@1.2.6@vue-ydui/dist/ydui.base.css
var ydui_base = __webpack_require__("Jtfc");
var ydui_base_default = /*#__PURE__*/__webpack_require__.n(ydui_base);

// CONCATENATED MODULE: ./src/utils/comm/vue.extend.js


/* harmony default export */ var vue_extend = ({
  initFunc: function initFunc() {
    /**
     * type: value  1品牌认证中；2品牌已认证；3品牌认证失败；4认证已过期；品牌未认证
     * */
    vue_esm["default"].filter('certFilter', function (type) {
      if (type === '1') {
        return '品牌认证中';
      } else if (type === '2') {
        return '品牌已认证';
      } else if (type === '3') {
        return '品牌认证失败';
      } else if (type === '4') {
        return '认证已过期';
      } else {
        return '品牌未认证';
      }
    });
    /**
     * type: value  1产品；2半成品；3原料；4设备；5采销品；6其他 7 代理
     * */
    vue_esm["default"].filter('goodsType', function (value) {
      switch (value) {
        case 1:
          return '产品';
        case 2:
          return '半成品';
        case 3:
          return '原料';
        case 4:
          return '设备';
        case 5:
          return '采销';
        case 6:
          return '其他';
        case 7:
          return '代理';
        default:
          return '自有';
      }
    }),
    /**
     * orderStatus: 订单状态过滤器  //无奈
     * pay_type:  1为支付宝，2为微信，3为银联 4网页支付宝 5公众号支付  6支付宝扫码支付 7微信扫码支付；8协议付款;9公众号溯源支付
     * pay_status:  支付状态      1为未支付，2为支付成功，3为逾期未支付（支付失败）
     * shipping_status:  物流状态  1为初始状态（未进入发货流程），2为待发货，3为待收货（也称为已发货），4为用户确认收货
     * order_status: 1为初始状态（未付款），2为未付款被买家取消，3为未付款被卖家取消 ，4为已付款（商家待确认, 舍弃该状态），
     *     5为已付款被买家取消，6已付款被卖家取消，7为商家确认（已支付成功才能确认），8为已完成（必须支付成功并且买家确认收货），9为售后状态
     * aftersale_status:  售后状态  1为初始状态（未进入售后流程）， 2为售后中， 3全部退款 4部分退款
     * refund_return:  退货退款状态:0是无退款,1有退款
     * comment_type:  退货退款状态:0是无评论,1有评论
     *
     * */
    vue_esm["default"].filter('orderStatus', function (data) {
      var statusName = '';
      data.order_status = data.order_status ? data.order_status : '1';
      data.shipping_status = data.shipping_status ? data.shipping_status : '1';
      if (data.order_status === 1) {
        statusName = '未付款';
      } else if (data.order_status === 2 || data.order_status === 3) {
        statusName = '已取消';
      } else if (data.order_status === 5) {
        statusName = '已取消';
      } else if (data.order_status === 6) {
        statusName = '已取消';
      } else if (data.order_status === 7) {
        if (data.shipping_status === 1) {
          statusName = '已付款';
        } else if (data.shipping_status === 2) {
          statusName = '待发货';
        } else if (data.shipping_status === 3 || data.shipping_status === 4) {
          statusName = '已发货';
        } else {
          statusName = '已付款';
        }
      } else if (data.order_status === 8) {
        statusName = '已完成';
      } else if (data.order_status === 9) {
        statusName = '已发货';
      } else {
        statusName = '未付款';
      }
      return statusName;
    });

    /**
     * 订单操作说明
     *  status； 1 未付款  2 已取消  3 已付款 代发货  4 已付款 物流状态中   5 已完成确认收货  6 已评价
     * */
    vue_esm["default"].prototype.orderOperation = function (data) {
      var status = 1;
      data.order_status = data.order_status ? data.order_status : 1;
      data.shipping_status = data.shipping_status ? data.shipping_status : 1;
      if (data.order_status === 1) {
        status = 1;
      } else if (data.order_status === 2 || data.order_status === 3 || data.order_status === 5 || data.order_status === 6) {
        status = 2;
      } else if (data.order_status === 7 && (data.shipping_status === 1 || data.shipping_status === 2)) {
        status = 3;
      } else if (data.order_status === 7 && (data.shipping_status === 3 || data.shipping_status === 4)) {
        status = 4;
      } else if (data.order_status === 8) {
        status = 5;
      } else if (data.order_status === 9) {
        status = 4;
      }
      if (data.is_comment) {
        status = 6;
      }
      return status;
    };
    /**
     * 订单售后状态
     * status； 1 申请退款  2  退款待审核  3 退款成功  4 退款失败  5 申请售后  6 退货待审核  7 退货中  8 退货成功  8 退货失败
     *          9 退款失败
     *
     *  `refund_return`：0 无退款 1 有退款  此状态要先判断是否有退款
     * `order_status` 1 未付款  2 已取消  3 已付款 代发货 4 已付款 物流状态中   5 已完成确认收货
     * `refund_type` int(1) NOT NULL DEFAULT '1' COMMENT '申请类型: 1为退款, 2为退货退款,',
     * `refund_status` tinyint(1) NOT NULL DEFAULT '1' COMMENT '申请状态:1为处理中,2已完成,3为取消退款,默认为1',
     * `seller_status` tinyint(1) NOT NULL DEFAULT '1' COMMENT '卖家处理状态:1为待审核,2为同意,3为不同意,默认为1',
     * `return_status` int(1) NOT NULL DEFAULT '1' COMMENT '退货状态:1无需退货,2待买家发货,3待卖家收货,4未收到,5已收到',
     * `goods_status` tinyint(1) NOT NULL DEFAULT '1' COMMENT '商品物流状态:1为待发货,2为待收货,3为未收到,4为已收货,默认为1',
     *
     * */
    vue_esm["default"].prototype.refundStatus = function (data) {
      var status = '';
      data.refund_status = data.refund_status ? data.refund_status : '';
      data.seller_status = data.seller_status ? data.seller_status : '';
      if (data.order_status >= 3) {
        if (data.goods_status === 1 && data.order_status === 3) {
          if (data.refund_return === 0) {
            status = 1;
          } else {
            if (data.refund_type === 1 && data.refund_status === 1) {
              status = 2;
            } else if (data.refund_type === 1 && data.refund_status === 3) {
              status = 1;
            } else if (data.refund_type === 1 && data.refund_status === 2 && data.seller_status === 2) {
              status = 3;
            } else if (data.refund_type === 1 && (data.refund_status === 2 || data.seller_status === 3)) {
              status = 4;
            }
          }
        } else {
          if (data.refund_return === 0) {
            status = 5;
          } else {
            if (data.refund_type === 1 && (data.refund_status === 1 || data.seller_status === 1)) {
              status = 2;
            } else if (data.refund_type === 1 && data.refund_status === 2 && data.seller_status === 2) {
              status = 3;
            } else if (data.refund_type === 1 && (data.refund_status === 2 || data.seller_status === 3)) {
              status = 4;
            }
            if (data.refund_type === 2 && (data.refund_status === 1 || data.seller_status === 1)) {
              status = 6;
            } else if (data.refund_type === 2 && data.refund_status === 2 && data.seller_status === 2 && (data.return_status === 2 || data.return_status === 3)) {
              status = 7;
            } else if (data.refund_type === 2 && data.refund_status === 2 && data.seller_status === 2 && data.return_status === 5) {
              status = 8;
            } else if (data.refund_type === 2 && (data.return_status === 4 || data.seller_status === 3)) {
              status = 9;
            }
          }
        }
      }
      return status;
    };
    /**
     * 订单售后状态
     * status； 1 申请退款  2  退款待审核  3 退款成功  4 退款失败  5 申请售后  6 退货待审核  7 退货中  8 退货成功  8 退货失败
     *
     *  `refund_return`：0 无退款 1 有退款  此状态要先判断是否有退款
     * `order_status` 1 未付款  2 已取消  3 已付款 代发货 4 已付款 物流状态中   5 已完成确认收货
     * `refund_type` int(1) NOT NULL DEFAULT '1' COMMENT '申请类型: 1为退款, 2为退货退款,',
     * `refund_status` tinyint(1) NOT NULL DEFAULT '1' COMMENT '申请状态:1为处理中,2已完成,3为取消退款,默认为1',
     * `seller_status` tinyint(1) NOT NULL DEFAULT '1' COMMENT '卖家处理状态:1为待审核,2为同意,3为不同意,默认为1',
     * `return_status` int(1) NOT NULL DEFAULT '1' COMMENT '退货状态:1无需退货,2待买家发货,3待卖家收货,4未收到,5已收到',
     * `goods_status` tinyint(1) NOT NULL DEFAULT '1' COMMENT '商品物流状态:1为待发货,2为待收货,3为未收到,4为已收货,默认为1',
     *
     * */
    vue_esm["default"].prototype.refundStatusName = function (data) {
      var status = '';
      data.refund_status = data.refund_status ? data.refund_status : '';
      data.seller_status = data.seller_status ? data.seller_status : '';
      if (data.refund_type === 1) {
        if (data.refund_status === 1 || data.seller_status === 1) {
          status = '退款中';
        } else if (data.refund_status === 2 && data.seller_status === 2) {
          status = '退款成功';
        } else if (data.refund_status === 2 || data.seller_status === 3) {
          status = '退款失败';
        }
      } else if (data.refund_type === 2) {
        if (data.refund_status === 1 || data.seller_status === 1) {
          status = '退货待审核';
        } else if (data.refund_status === 2 && data.seller_status === 2 && (data.return_status === 2 || data.return_status === 3)) {
          status = '退货中';
        } else if (data.refund_status === 2 && data.seller_status === 2 && data.return_status === 5) {
          status = '退货成功';
        } else if (data.return_status === 4 || data.seller_status === 3) {
          status = '退货失败';
        }
      }
      return status;
    };
  }
});
// EXTERNAL MODULE: ./node_modules/_vuex@3.1.2@vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("48sp");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/comm/mapAComponent/mapAComponent.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import AMapComponent from 'src/components/common/amapComponent'
/* harmony default export */ var mapAComponent = ({
  name: "map-a-component",
  data: function data() {
    return {
      title: '地理位置',
      mapHeight: 680,
      longitude: 116.404,
      latitude: 39.915,
      description: '天安门',
      farmid: '',
      show: false,
      ctime: '',
      nickname: '',
      isZnw: false
    };
  },
  mounted: function mounted() {},
  updated: function updated() {
    if (this.show) {
      this.initMap();
      var _this = this;
      window.onpopstate = function (e) {
        _this.show = false;
      };
    }
  },

  computed: {
    mapStyle: function mapStyle() {
      return {
        width: '100%',
        height: this.mapHeight + 'px'
      };
    }
  },
  methods: {
    //初始化获取数据
    initMap: function initMap() {
      var longitude = this.longitude;
      var latitude = this.latitude;
      var map = new AMap.Map('amapContainer', {
        zoom: 15, //级别
        center: [longitude, latitude], //中心点坐标
        viewMode: '3D' //使用3D视图
      });
      addMarker();
      function addMarker() {
        map.clearMap();
        var marker = new AMap.Marker({
          map: map,
          position: [longitude, latitude]
        });
      }
    },
    goBack: function goBack() {
      this.show = false;
      history.back();
    }
  },
  watch: {
    show: function show(newV, oldV) {
      if (newV) {
        var loca = location.href;
        history.pushState({}, 'mapComp', loca + '#map');
      } /*else{
         this.$router.go(-1)
        }*/
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/comm/mapAComponent/mapAComponent.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import AMapComponent from 'src/components/common/amapComponent'
/* harmony default export */ var mapAComponent_mapAComponent = ({
  name: "map-a-component",
  data: function data() {
    return {
      title: '地理位置',
      mapHeight: 680,
      longitude: 116.404,
      latitude: 39.915,
      description: '天安门',
      farmid: '',
      show: false,
      ctime: '',
      nickname: '',
      isZnw: false
    };
  },
  mounted: function mounted() {},
  updated: function updated() {
    if (this.show) {
      this.initMap();
      var _this = this;
      window.onpopstate = function (e) {
        _this.show = false;
      };
    }
  },

  computed: {
    mapStyle: function mapStyle() {
      return {
        width: '100%',
        height: this.mapHeight + 'px'
      };
    }
  },
  methods: {
    //初始化获取数据
    initMap: function initMap() {
      var longitude = this.longitude;
      var latitude = this.latitude;
      var map = new AMap.Map('amapContainer', {
        zoom: 15, //级别
        center: [longitude, latitude], //中心点坐标
        viewMode: '3D' //使用3D视图
      });
      addMarker();
      function addMarker() {
        map.clearMap();
        var marker = new AMap.Marker({
          map: map,
          position: [longitude, latitude]
        });
      }
    },
    goBack: function goBack() {
      this.show = false;
      history.back();
    }
  },
  watch: {
    show: function show(newV, oldV) {
      if (newV) {
        var loca = location.href;
        history.pushState({}, 'mapComp', loca + '#map');
      } /*else{
         this.$router.go(-1)
        }*/
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-340f74a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/comm/mapAComponent/mapAComponent.vue
var mapAComponent_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"map_container_box"},[_c('section',{staticClass:"map_container"},[_c('div',{style:(_vm.mapStyle),attrs:{"id":"amapContainer"}})]),_vm._v(" "),(_vm.isZnw)?_c('div',{staticClass:"map_address"},[(_vm.nickname)?_c('div',{staticClass:"map-item"},[_c('span',{staticClass:"map_label_left"},[_vm._v("拍摄人员")]),_c('span',{staticClass:"map_descrip"},[_vm._v(_vm._s(_vm.nickname))])]):_vm._e(),_vm._v(" "),(_vm.ctime)?_c('div',{staticClass:"map-item"},[_c('span',{staticClass:"map_label_left"},[_vm._v("拍摄时间")]),_c('span',{staticClass:"map_descrip"},[_vm._v(_vm._s(_vm.ctime))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"map-item"},[_c('span',{staticClass:"map_label_left"},[_vm._v("拍摄地点")]),_c('span',{staticClass:"map_descrip"},[_vm._v(_vm._s(_vm.description))])])]):_c('div',{staticClass:"map_address"},[_c('div',{staticClass:"map-item",staticStyle:{"justify-content":"center"}},[_c('span',{staticClass:"map_descrip"},[_vm._v(_vm._s(_vm.description))])])]),_vm._v(" "),_c('div',{staticClass:"map_back"},[_c('span',{staticClass:"map_back_img",on:{"click":_vm.goBack}},[_c('img',{attrs:{"src":__webpack_require__("Uf5E")}})])])]):_vm._e()}
var mapAComponent_staticRenderFns = []
var mapAComponent_esExports = { render: mapAComponent_render, staticRenderFns: mapAComponent_staticRenderFns }
/* harmony default export */ var comm_mapAComponent_mapAComponent = (mapAComponent_esExports);
// CONCATENATED MODULE: ./src/components/comm/mapAComponent/mapAComponent.vue
function mapAComponent_injectStyle (ssrContext) {
  __webpack_require__("LulU")
}
var mapAComponent_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var mapAComponent___vue_template_functional__ = false
/* styles */
var mapAComponent___vue_styles__ = mapAComponent_injectStyle
/* scopeId */
var mapAComponent___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mapAComponent___vue_module_identifier__ = null
var mapAComponent_Component = mapAComponent_normalizeComponent(
  mapAComponent_mapAComponent,
  comm_mapAComponent_mapAComponent,
  mapAComponent___vue_template_functional__,
  mapAComponent___vue_styles__,
  mapAComponent___vue_scopeId__,
  mapAComponent___vue_module_identifier__
)

/* harmony default export */ var components_comm_mapAComponent_mapAComponent = (mapAComponent_Component.exports);

// EXTERNAL MODULE: ./node_modules/_object-assign@4.1.1@object-assign/index.js
var _object_assign_4_1_1_object_assign = __webpack_require__("+Up5");
var _object_assign_4_1_1_object_assign_default = /*#__PURE__*/__webpack_require__.n(_object_assign_4_1_1_object_assign);

// CONCATENATED MODULE: ./src/components/comm/mapAComponent/index.js




function mergeOptions($vm, options) {
  var defaults = {};
  for (var i in $vm.$options.props) {
    if (i !== 'value') {
      defaults[i] = $vm.$options.props[i].default;
    }
  }
  var _options = _object_assign_4_1_1_object_assign_default()({}, defaults, options);
  for (var _i in _options) {
    $vm[_i] = _options[_i];
  }
}

var MapAObj = {};
MapAObj.install = function (Vue) {
  Vue.prototype.$mapA = {};
  var mapMain = Vue.extend(components_comm_mapAComponent_mapAComponent);
  var instance = new mapMain({
    el: document.createElement('div')
  });

  var parent = document.getElementById('app');
  document.body.appendChild(instance.$el);
  Vue.prototype.$mapA.show = function () {
    var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    instance = assign_default()(instance, {
      show: true,
      mapHeight: 680,
      longitude: 116.404,
      latitude: 39.915,
      description: '天安门'
      /*data:[],
      onOk(e){
        console.log(e)
        console.log('选中回调')
      },
      onCancel(){
        console.log('取消回调')
      }*/
    });
    mergeOptions(instance, settings);
  };
  Vue.prototype.$mapA.hide = function () {
    instance.show = false;
  };
};
/* harmony default export */ var comm_mapAComponent = (MapAObj);
// CONCATENATED MODULE: ./src/main.js


















__webpack_require__("Tn+o");
__webpack_require__("DMSW");
__webpack_require__("d6ST");
__webpack_require__("O4O2");













vue_esm["default"].component('block', src_components_comm_block);


vue_esm["default"].directive('transfer-dom', transfer_dom["a" /* default */]);

vue_esm["default"].use(device["a" /* default */]);
vue_esm["default"].use(toast["a" /* default */]);
vue_esm["default"].use(plugins_alert["a" /* default */]);
vue_esm["default"].use(plugins_confirm["a" /* default */]);
vue_esm["default"].use(loading["a" /* default */]);

vue_esm["default"].use(ajax["a" /* default */]);
vue_esm["default"].use(datetime["a" /* default */]);
vue_esm["default"].use(vue_clipboard_default.a);
vue_esm["default"].use(element_ui_common_default.a);


vue_esm["default"].component(slider["Slider"].name, slider["Slider"]);
vue_esm["default"].component(slider["SliderItem"].name, slider["SliderItem"]);


vue_esm["default"].use(vue_router_esm["a" /* default */]);
vue_esm["default"].use(store["a" /* default */]);
vue_extended.install(vue_esm["default"]);
fastclick_default.a.attach(document.body);
vue_esm["default"].config.productionTip = false;
vue_esm["default"].use(close_dialogs["a" /* default */], router["a" /* default */]);
Object(_vuex_router_sync_5_0_0_vuex_router_sync["sync"])(store["a" /* default */], router["a" /* default */]);
/* eslint-disable no-new */
vue_esm["default"].prototype.$axios = _axios_0_18_0_axios_default.a;
vue_esm["default"].prototype.func = func_default.a;

vue_extend.initFunc();


vue_esm["default"].use(comm_mapAComponent);

router["a" /* default */].beforeEach(function (to, from, next) {
  if (to.meta.requireAuth) {
    var token = localStorage.token;
    if (token) {
      next();
    } else {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    }
  } else {
    next();
  }
});

new vue_esm["default"]({
  router: router["a" /* default */],
  store: store["a" /* default */],
  beforeMount: function beforeMount() {},
  mounted: function mounted() {},
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "O4O2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T0IC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tn+o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tnhg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Uf5E":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "VSKm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("HzJ8");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./node_modules/_vue@2.6.11@vue/dist/vue.esm.js
var vue_esm = __webpack_require__("kV13");

// EXTERNAL MODULE: ./node_modules/_vue-router@3.1.5@vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("p7sN");

// EXTERNAL MODULE: ./src/store/index.js
var store = __webpack_require__("IcnI");

// CONCATENATED MODULE: ./src/router/comm-router.js
var commRouter = [{
  path: '/',
  redirect: '/shoppingMalll/index'
}, {
  path: '/login/index',
  name: '登录',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(39)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("jT7l")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/login/phone-login',
  name: '手机号登录',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(47)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("WFNk")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/login/wx-login',
  name: '微信登录',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(35)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("dLqk")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/shoppingMalll/index/:storeId*', // /shoppingMalll/index/5314
  name: '商城',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("tJGW")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/shoppingMalll/search',
  name: '搜索',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(27)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Vlid")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/shoppingMalll/goodDetails/:goodsId*',
  name: '商品详情',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(11)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("LKy9")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/shoppingMalll/order',
  name: '提交订单',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(25)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("W9I6")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/shoppingMalll/address-list',
  name: '选择收货地址',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(29)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("raJg")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/shoppingMalll/address-add',
  name: '选择收货地址',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("hlCb")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/shoppingMalll/address-edit',
  name: '修改收货地址',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(31)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("NFuH")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/brand/index',
  // path: '/brand/index/:post_id',
  name: '品牌',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(9)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("eMhh")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/brand/view/:id/:uid/:type',
  name: '文章',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(7)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("DUmc")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/brand/active/:id/:uid/:type',
  name: '动态',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(13)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ZOzF")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/brand/living',
  name: '直播',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(32)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("iJbU")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/brand/monitor',
  name: '监控列表',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(41)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("HyMH")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/brand/monitor-index',
  name: '监控',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(36)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("efxr")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/shoppingcart/index/:isOrigin*',
  name: '购物车',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(19)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("yk7H")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/shoppingcart/order',
  name: '结算',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(24)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("KQ/w")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/shoppingcart/order-pay',
  name: '支付',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(22)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("U7SK")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/service/index',
  name: '客服',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("bznk")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/service/list',
  name: '客服列表',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(45)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Meoy")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/me/index',
  name: '我的',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(12)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("1+Lu")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/me/seting',
  name: '设置',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(40)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("MoW2")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/me/active-follow',
  name: '动态关注',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(33)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("4cwc")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/me/goods-follow',
  name: '商品关注',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(38)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("z+WL")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/me/store-follow',
  name: '商家关注',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(43)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("bsTc")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/me/collection',
  name: '收藏',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(46)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Vpkt")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/me/follow-index',
  name: '关注',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("PR/G")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/me/share-index',
  name: '分享',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(14)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("cZnr")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/me/download',
  name: '下载',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(30)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("aro4")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/follow/card-index',
  name: '关注名片',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(20)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("voyX")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/order/index',
  name: '我的订单',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(21)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("0wiy")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/order/details',
  name: '订单详情',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("TP7y")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/order/multiple-logistics',
  name: '物流详情',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(37)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("YDDA")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/order/logistics-details',
  name: '物流详情',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(15)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("53q1")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/order/apply-service',
  name: '申请售后',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(50)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("/E6U")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/order/apply-service-refund',
  name: '申请售后退款',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(16)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("mU2y")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/order/apply-refund',
  name: '申请退款',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(26)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("I86e")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/order/refund-details',
  name: '退款详情',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(44)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("kV46")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/order/logistics-form-data',
  name: '退货物流信息填写',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(42)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("d1fe")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/order/evaluate',
  name: '评价',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(8)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("qnuh")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/order/evaluate-details',
  name: '评价',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(18)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("WcrI")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/trace/index',
  name: '溯源',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("IuUG")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/trace/scan-check',
  name: '防伪校验',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(34)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("eGow")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, { // 文字留言路由
  path: '/message/message-board',
  name: '文字留言板',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(23)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("N5ev")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '*',
  redirect: '/404'
}];
/* harmony default export */ var comm_router = (commRouter);
// CONCATENATED MODULE: ./src/router/page-out-router.js
var pageOutRouter = [{
  path: '/mall/index/:id',
  name: '商城首页',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("5JIj")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }

}, {
  path: '/mall/rebate-rule',
  name: '返利规则',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(48)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("A508")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/mall/income-rule',
  name: '收入提现',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(49)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("FIQQ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/mall/sy-info/:id',
  name: '追溯信息',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(17)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Et7W")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/mall/view/:id/:userid', //:    /mall/view/4282/12200/1
  name: '长文章',
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(28)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("NxV0")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}];
/* harmony default export */ var page_out_router = (pageOutRouter);
// CONCATENATED MODULE: ./src/router/index.js







var router_history = window.sessionStorage;
var historyCount = router_history.getItem('count') * 1 || 0;
var historyPath = {
  lengthNum: historyCount
};

vue_esm["default"].use(vue_router_esm["a" /* default */]);
vue_esm["default"].use(store["a" /* default */]);
var routeList = [];
var router_updateRoute = function updateRoute(router) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = get_iterator_default()(router), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      routeList.push(item);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};
router_updateRoute([]);
router_updateRoute(comm_router);
router_updateRoute(page_out_router);

var routers = new vue_router_esm["a" /* default */]({
  mode: 'hash',
  // mode: 'history',
  routes: routeList
});
// 修改标题
routers.beforeEach(function (to, from, next) {
  store["a" /* default */].commit('updateLoadingStatus', { isLoading: true });

  /*const toIndex = history.getItem(to.path)
  const fromIndex = history.getItem(from.path)
   if (toIndex) {
    if (!fromIndex || parseInt(toIndex, 10) > parseInt(fromIndex, 10) || (toIndex === '0' && fromIndex === '0')) {
      store.commit('updateDirection', {direction: 'forward'})
    } else {
      store.commit('updateDirection', {direction: 'reverse'})
    }
  } else {
    ++historyCount
    history.setItem('count', historyCount)
    to.path !== '/' && history.setItem(to.path, historyCount)
    store.commit('updateDirection', {direction: 'forward'})
  }*/

  if (to.meta.title) {
    store["a" /* default */].commit('updateTitle', { updateTitle: to.meta.title });
  }
  next();
});
routers.afterEach(function (to) {
  try {
    document.querySelector('.scroll')[0].scrollTop = 0;
  } catch (e) {}
});
/* harmony default export */ var src_router = __webpack_exports__["a"] = (routers);

/***/ }),

/***/ "YlSV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b5lX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bT6r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("x6d+");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-1fa4d632","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("HCAt")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var _vux_2_9_4_vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bwZx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d6ST":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dJYW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("ZLEe");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/components/icon/index.vue + 3 modules
var icon = __webpack_require__("GRuq");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/components/datetime/datetimepicker.js + 3 modules
var datetimepicker = __webpack_require__("eSZc");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/libs/clean-style.js
var clean_style = __webpack_require__("gjrJ");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-9cbac0a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/group/index.vue
var group_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('div',{staticClass:"weui-cells__title",style:(_vm.cleanStyle({
    color: _vm.titleColor
  })),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"weui-cells",class:{
    'vux-no-group-title': !_vm.title
  },style:(_vm.cleanStyle({
    marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
  }))},[_vm._t("after-title"),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.footerTitle)?_c('div',{staticClass:"weui-cells__title vux-group-footer-title",style:(_vm.cleanStyle({
    color: _vm.footerTitleColor
  })),domProps:{"innerHTML":_vm._s(_vm.footerTitle)}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: group_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_group = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/group/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("MdGl")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_group,
  src_components_group,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var _vux_2_9_4_vux_src_components_group = (Component.exports);

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/components/inline-desc/index.vue + 3 modules
var inline_desc = __webpack_require__("4a+h");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/mixins/uuid.js
var uuid = __webpack_require__("trHK");

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/tools/date/format.js
var date_format = __webpack_require__("eFjK");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/datetime/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var datetime = ({
  name: 'datetime',
  mixins: [uuid["a" /* default */]],
  components: {
    Group: _vux_2_9_4_vux_src_components_group,
    InlineDesc: inline_desc["a" /* default */],
    Icon: icon["a" /* default */]
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = keys_default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new datetimepicker["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = Object(date_format["a" /* default */])(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/datetime/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var components_datetime = ({
  name: 'datetime',
  mixins: [uuid["a" /* default */]],
  components: {
    Group: _vux_2_9_4_vux_src_components_group,
    InlineDesc: inline_desc["a" /* default */],
    Icon: icon["a" /* default */]
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = keys_default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new datetimepicker["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = Object(date_format["a" /* default */])(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-73feec0b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/datetime/index.vue
var datetime_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"vux-datetime weui-cell",class:{'weui-cell_access': !_vm.readonly},attrs:{"data-cancel-text":'取消',"data-confirm-text":'确定',"href":"javascript:"}},[_vm._t("default",[_c('div',[_vm._t("title",[_c('p',{class:_vm.labelClass,style:(_vm.styles),domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft vux-cell-primary vux-datetime-value",style:({
        textAlign: _vm.valueTextAlign
      })},[(!_vm.currentValue && _vm.placeholder)?_c('span',{staticClass:"vux-cell-placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.currentValue)?_c('span',{staticClass:"vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat ? _vm.displayFormat(_vm.currentValue) : _vm.currentValue))]):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.valid),expression:"!valid"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":_vm.firstError}})],1)])],2)}
var datetime_staticRenderFns = []
var datetime_esExports = { render: datetime_render, staticRenderFns: datetime_staticRenderFns }
/* harmony default export */ var src_components_datetime = (datetime_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/datetime/index.vue
function datetime_injectStyle (ssrContext) {
  __webpack_require__("YlSV")
}
var datetime_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var datetime___vue_template_functional__ = false
/* styles */
var datetime___vue_styles__ = datetime_injectStyle
/* scopeId */
var datetime___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var datetime___vue_module_identifier__ = null
var datetime_Component = datetime_normalizeComponent(
  components_datetime,
  src_components_datetime,
  datetime___vue_template_functional__,
  datetime___vue_styles__,
  datetime___vue_scopeId__,
  datetime___vue_module_identifier__
)


/* harmony default export */ var _vux_2_9_4_vux_src_components_datetime = __webpack_exports__["a"] = (datetime_Component.exports);


/***/ }),

/***/ "exP/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f9nr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("fRcE");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var src_components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-336e027e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/alert/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-alert"},[_c('x-dialog',{attrs:{"mask-transition":_vm.maskTransition,"dialog-transition":_vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')},"on-show":function($event){return _vm.$emit('on-show')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"weui-dialog__hd"},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_primary",attrs:{"href":"javascript:;"},on:{"click":_vm._onHide}},[_vm._v(_vm._s(_vm.buttonText || '确定'))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _vux_2_9_4_vux_src_components_alert = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/alert/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("33rv")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_alert,
  _vux_2_9_4_vux_src_components_alert,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var node_modules__vux_2_9_4_vux_src_components_alert = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fRcE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/mixins/prevent-body-scroll.js
var prevent_body_scroll = __webpack_require__("v4/V");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-113674a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/x-dialog/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":_vm.hide}})]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/x-dialog/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("bwZx")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var _vux_2_9_4_vux_src_components_x_dialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "flW4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("3cXf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("rVsN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("aA9S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("aozt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_querystring__ = __webpack_require__("Umb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("kV13");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui__ = __webpack_require__("wSez");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_alias_router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_urls__ = __webpack_require__("imha");










var baseUrl = __WEBPACK_IMPORTED_MODULE_8__config_urls__["a" /* default */].getBaseUrl();

//拦截请求
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.request.use(function (config) {
    config.headers = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, config.headers || {}, {
        'client': '2',
        token: localStorage.token
    });
    if (((config.method || '').toLowerCase() === 'post' || (config.method || '').toLowerCase() === 'put' || (config.method || '').toLowerCase() === 'patch') && config.data && !config.headers['Content-Type']) {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        config.data = __WEBPACK_IMPORTED_MODULE_4_querystring___default.a.stringify(config.data);
    }

    if (config.url.indexOf('?') < 0) {
        config.url += '?_=' + new Date().getTime();
    } else {
        config.url += '&_=' + new Date().getTime();
    }
    return config;
}, function (error) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
});

//拦截响应
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
});

function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    }

    if (response.data.status === -1) {
        sessionStorage.removeItem('token');
        window.location.replace('/');
    }

    var errortext = response.statusText;
    var error = new Error(errortext);
    error.name = response.status;
    error.response = response;
    throw error;
}

//存储正在请求中的ajax
var AJATOKEN = {};
function compileAjaxToken(option) {
    option = option || {};
    var token = option.url + option.method + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(option.data || option.params || {});
    return token;
}
var http = function http(option, token) {

    //判断重复请求
    var donotRepeat = option.doNotRepeat === void 0 ? true : option.doNotRepeat;
    if (donotRepeat) {
        if (AJATOKEN[token]) {
            var _then = {
                then: function then() {
                    return _then;
                },
                catch: function _catch() {}
            };
            return _then;
        }
        AJATOKEN[token] = true;
    }
    option.headers = option.headers || {};
    if (option.showLoading !== false) {
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].$vux.loading.show("请求中");
    }
    return __WEBPACK_IMPORTED_MODULE_3_axios___default()(option).then(checkStatus).then(function (res) {
        delete AJATOKEN[token];
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].$vux.loading.hide();
        if (!res.data.hasOwnProperty('status') && res.data) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve({
                status: 0,
                msg: '请求成功',
                data: res.data || {},
                fullData: res.data
            });
        } else if (res.data.status === '0' || res.data.key || res.data.hash) {
            localStorage.setItem('isPull', 1);
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve({
                status: res.data.status,
                data: res.data.msg,
                fullData: res.data
            });
        } else if (res.data.status === '4') {
            __WEBPACK_IMPORTED_MODULE_5_vue__["default"].$vux.toast.text(res.data.data.err_code_des);
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject({
                status: res.data.status,
                msg: res.data.message,
                data: res.data.data,
                fullData: res.data
            });
        } else {
            if (res.data.status === '9') {
                localStorage.removeItem('token');
                // router.push('/login');
            }
            __WEBPACK_IMPORTED_MODULE_5_vue__["default"].$vux.toast.text(res.data.msg || '请求异常!');
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject({
                status: res.data.status,
                msg: res.data.message,
                data: res.data.data || {},
                fullData: res.data
            });
        }
    });
};

function request(option) {
    option = option || {};
    var token = compileAjaxToken(option);
    var promise = http(option, token);
    setTimeout(function () {
        promise.catch(function (error) {
            console.log(2222, error);
            delete AJATOKEN[token];
            __WEBPACK_IMPORTED_MODULE_5_vue__["default"].$vux.loading.hide();
            if (error.status === void 0) {
                // Vue.$vux.toast.text('系统出现故障了，请稍后再试');
            }
            return {};
        });
    });
    return promise;
}

/* harmony default export */ __webpack_exports__["a"] = (request);

/***/ }),

/***/ "imha":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("kV13");

var urls = {
    centerDevUrl: '',
    centerProUrl: ''
};
var nodeEnv = "production";
/* harmony default export */ __webpack_exports__["a"] = ({
    getBaseUrl: function getBaseUrl() {
        if (nodeEnv === 'production') {
            return urls.centerProUrl;
        } else {
            return urls.centerDevUrl;
        }
    }
});
if (nodeEnv === 'production') {
    // 正式-真信网络公众号 wx8b9d724bdd9eb38d，测试 wxffb481a62616661d
    // appKey : "25wehl3u27niw", // "qd46yzrfq3c5f", 正式   "25wehl3u27niw", 测试  融云的聊天 appKey
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.configData = {
        AppID: 'wx8b9d724bdd9eb38d',
        appKey: "qd46yzrfq3c5f",
        callbackURL: '/store'
    };
} else {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.configData = {
        AppID: 'wxffb481a62616661d',
        appKey: "25wehl3u27niw",
        callbackURL: ''
        // AppID: 'wx8b9d724bdd9eb38d',
        // appKey : "qd46yzrfq3c5f",
    };
}

/***/ }),

/***/ "kXXg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n0LP":
/***/ (function(module, exports) {

/**
 * TODO:系统扩展类库
 */
// =====================================日期类型===========================================================================
/**
 * 将数字格式化为两位数
 * @param num
 * @returns {string}
 */
var dNumber = function dNumber(num) {
  return num < 10 ? '0' + num : num;
};
/**
 * 日期格式化
 * @param format
 * 格式化参数，支持各种日期格式
 * @returns {string}
 * 返回格式化后日期
 */
/* eslint-disable no-extend-native */
/* eslint-disable indent */
Date.prototype.dateFormart = Date.prototype.dateFormart || function (format) {
  /* eslint-disable no-useless-escape */
  if (isNaN(this.getTime())) {
    return '';
  }
  var formatString = format.match(/[A-Za-z]{1,4}|[\--\/-年-月-日-时-分-秒-\s-:]/g);
  var date = [];
  for (var i = 0, len = formatString.length; i < len; i++) {
    switch (formatString[i]) {
      case 'yyyy':
        date.push(this.getFullYear());
        break;
      case 'yy':
        date.push(this.getYear());
        break;
      case 'MM':
        var month = this.getMonth() + 1;
        date.push(dNumber(month));
        break;
      case 'M':
        date.push(this.getMonth() + 1);
        break;
      case 'dd':
        date.push(dNumber(this.getDate()));
        break;
      case 'd':
        date.push(this.getDate());
        break;
      case 'HH':
        date.push(dNumber(this.getHours()));
        break;
      case 'H':
        date.push(this.getHours());
        break;
      case 'mm':
        date.push(dNumber(this.getMinutes()));
        break;
      case 'm':
        date.push(this.getMinutes());
        break;
      case 'ss':
        date.push(dNumber(this.getSeconds()));
        break;
      case 's':
        date.push(this.getSeconds());
        break;
      default:
        date.push(formatString[i]);
        break;
    }
  }
  return date.join('');
};
window.FixedDateIOS = function (date) {
  try {
    date = date.replace(/-/g, '/');
  } catch (e) {}
  return new Date(date);
};
Date.prototype.toDateInputValue = function () {
  var local = new Date(this);
  local.setMinutes(this.getMinutes() - this.getTimezoneOffset());
  return local.toJSON().slice(0, 10);
};
/**
 * 洗牌算法，数组随机打乱
 * @type {Function}
 */
Array.prototype.randomArrByArg = Array.prototype.randomArrByArg || function () {
  var index = void 0;
  var temp = void 0;
  var len = this.length;
  // 打乱数组
  for (var i = 0; i < len; i++) {
    // 产生从 i 到 length 之间的随机数
    index = parseInt(Math.random() * (length - i)) + i;
    if (index !== i && index < len && index > -1) {
      temp = this[i];
      this[i] = this[index];
      this[index] = temp;
    }
  }
  return this;
};
// 获取周几
Date.prototype.getWeek = function () {
  var week = this.getDay();
  switch (week) {
    case 1:
      return '周一';
    case 2:
      return '周二';
    case 3:
      return '周三';
    case 4:
      return '周四';
    case 5:
      return '周五';
    case 6:
      return '周六';
    default:
      return '周日';
  }
};
// 返回星期+日期
Date.prototype.getWeekAndDate = function () {
  var week = this.getWeek();
  var date = this.dateFormart('MM/dd');
  return week + ' ' + date;
};

/***/ }),

/***/ "u8ew":
/***/ (function(module, exports) {

(function (doc, win) {
  var docEl = doc.documentElement;
  /**
   * 获取元素离顶部的距离
   * @param element
   * @returns {number}
   */
  var getElementViewTop = function getElementViewTop(element) {
    var actualTop = element.offsetTop;
    var current = element.offsetParent;
    while (current !== null && current) {
      actualTop += current.offsetTop;
      current = current.offsetParent;
    }
    var elementScrollTop = document.documentElement.scrollTop;
    return actualTop - elementScrollTop;
  };
  // 软键盘高度
  var keyHeight = 0;
  /**
   * 浏览器视口高度
   * @returns {Number|number}
   */
  var viewportHeight = function viewportHeight() {
    return window.innerHeight || docEl.clientHeight || doc.body.clientHeight;
  };
  // 初始视口高度
  var BodyHeight = viewportHeight();
  /**
   * 获取软键盘的高度
   * @param callBack
   * 回调函数执行位置变化
   */
  var keyboardHeight = function keyboardHeight(callBack) {
    if (!keyHeight) {
      setTimeout(function () {
        var nowBodyHeight = viewportHeight();
        if (!nowBodyHeight) {
          keyboardHeight();
        }
        keyHeight = BodyHeight - nowBodyHeight;
        callBack(keyHeight);
      }, 600);
    } else {
      callBack(keyHeight);
    }
  };
  /**
   * 重置滚动条位置
   * @param scrollTop
   */
  var restAppScrollTop = function restAppScrollTop(scrollTop) {
    doc.querySelector('#app').scrollTop = scrollTop || 0;
  };
  var elem = '';
  var inputUpdate = function inputUpdate(e) {
    if (e && (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA')) {
      elem = e.target;
    }
  };
  var blurTo = function blurTo() {
    inputUpdate();
    var app = doc.querySelector('#app');
    var appScrollTop = app.scrollTop;
    var appHeight = app.scrollHeight;
    keyboardHeight(function (kh) {
      var nowHeight = viewportHeight();
      if (getElementViewTop(elem) > nowHeight || BodyHeight > appHeight) {
        if (BodyHeight > nowHeight) {
          restAppScrollTop(appScrollTop + kh);
        } else if (BodyHeight === nowHeight) {
          restAppScrollTop(appScrollTop - kh);
        }
      }
    });
  };
  // 获取焦点
  doc.addEventListener('focus', blurTo, true);
  // 失去焦点
  doc.addEventListener('blur', blurTo, true);
  // doc.addEventListener('DOMContentLoaded', blurTo, false)
})(document, window);

/***/ }),

/***/ "xfkp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["_14"] = login;
/* harmony export (immutable) */ __webpack_exports__["_18"] = smsSender;
/* harmony export (immutable) */ __webpack_exports__["_21"] = wxLogin;
/* harmony export (immutable) */ __webpack_exports__["_12"] = findUserAttentionBrandTrends;
/* harmony export (immutable) */ __webpack_exports__["i"] = createAccountAddress;
/* harmony export (immutable) */ __webpack_exports__["x"] = findAccountAddressByAddressId;
/* harmony export (immutable) */ __webpack_exports__["u"] = deleteAccountAddress;
/* harmony export (immutable) */ __webpack_exports__["_19"] = switchDefaultAccountAddress;
/* harmony export (immutable) */ __webpack_exports__["L"] = findDistrict;
/* harmony export (immutable) */ __webpack_exports__["y"] = findAccountAddressListByAccountId;
/* unused harmony export getDistrict */
/* harmony export (immutable) */ __webpack_exports__["_3"] = findStoreByStoreId;
/* harmony export (immutable) */ __webpack_exports__["_5"] = findStoreGoodsCategoryList;
/* harmony export (immutable) */ __webpack_exports__["_6"] = findStoreGoodsList;
/* harmony export (immutable) */ __webpack_exports__["_8"] = findStoreGoodsListByStoreId;
/* harmony export (immutable) */ __webpack_exports__["_7"] = findStoreGoodsListByDirection;
/* harmony export (immutable) */ __webpack_exports__["_16"] = searchStoreGoodsListByKeyword;
/* harmony export (immutable) */ __webpack_exports__["D"] = findBrand;
/* harmony export (immutable) */ __webpack_exports__["_4"] = findStoreGoods;
/* harmony export (immutable) */ __webpack_exports__["V"] = findProductIntroduceListByProductId;
/* harmony export (immutable) */ __webpack_exports__["G"] = findBrandOriginListByBrandId;
/* harmony export (immutable) */ __webpack_exports__["W"] = findProductTrace;
/* harmony export (immutable) */ __webpack_exports__["R"] = findOrderCommentList;
/* harmony export (immutable) */ __webpack_exports__["I"] = findBrandTrendList;
/* harmony export (immutable) */ __webpack_exports__["H"] = findBrandTrendDetail;
/* harmony export (immutable) */ __webpack_exports__["P"] = findOfficialStoreGoodsList;
/* harmony export (immutable) */ __webpack_exports__["t"] = createShoppingCart;
/* unused harmony export findShoppingCartListByAccountId */
/* harmony export (immutable) */ __webpack_exports__["_2"] = findShoppingCartList;
/* harmony export (immutable) */ __webpack_exports__["c"] = attentionStore;
/* harmony export (immutable) */ __webpack_exports__["b"] = attentionBrand;
/* harmony export (immutable) */ __webpack_exports__["g"] = changeShoppingCartNum;
/* harmony export (immutable) */ __webpack_exports__["h"] = clearInvalidShoppingCart;
/* harmony export (immutable) */ __webpack_exports__["m"] = createBatchAttentionGoods;
/* harmony export (immutable) */ __webpack_exports__["f"] = changeShoppingCartGoodsSpec;
/* harmony export (immutable) */ __webpack_exports__["w"] = deleteShoppingCartGoods;
/* harmony export (immutable) */ __webpack_exports__["K"] = findDefaultAccountAddress;
/* harmony export (immutable) */ __webpack_exports__["_1"] = findSelectedGoodsList;
/* harmony export (immutable) */ __webpack_exports__["p"] = createOrder;
/* harmony export (immutable) */ __webpack_exports__["U"] = findOrders;
/* harmony export (immutable) */ __webpack_exports__["_15"] = pay;
/* harmony export (immutable) */ __webpack_exports__["a"] = aliWapPay;
/* unused harmony export findBrandTrendByTrendId */
/* harmony export (immutable) */ __webpack_exports__["j"] = createAccountBrandTrendFavorite;
/* harmony export (immutable) */ __webpack_exports__["k"] = createAttentionBrandTrend;
/* harmony export (immutable) */ __webpack_exports__["o"] = createBrandTrendCommentZambia;
/* harmony export (immutable) */ __webpack_exports__["n"] = createBrandTrendComment;
/* harmony export (immutable) */ __webpack_exports__["z"] = findAccountCardList;
/* harmony export (immutable) */ __webpack_exports__["_17"] = sendOrderNotice;
/* harmony export (immutable) */ __webpack_exports__["S"] = findOrderDetail;
/* harmony export (immutable) */ __webpack_exports__["_20"] = updateOrderAddress;
/* harmony export (immutable) */ __webpack_exports__["v"] = deleteOrderByOrderId;
/* harmony export (immutable) */ __webpack_exports__["T"] = findOrderLogisticsInfo;
/* harmony export (immutable) */ __webpack_exports__["X"] = findRongCloudUser;
/* harmony export (immutable) */ __webpack_exports__["Z"] = findRongMessageList;
/* harmony export (immutable) */ __webpack_exports__["Y"] = findRongMessageDetailList;
/* harmony export (immutable) */ __webpack_exports__["_9"] = findTempKeys;
/* harmony export (immutable) */ __webpack_exports__["s"] = createRefundOrder;
/* harmony export (immutable) */ __webpack_exports__["q"] = createOrderAfterLogisticsInfo;
/* harmony export (immutable) */ __webpack_exports__["Q"] = findOrderAfterInfo;
/* harmony export (immutable) */ __webpack_exports__["e"] = cancelRefundOrder;
/* harmony export (immutable) */ __webpack_exports__["d"] = cancelOrderByOrderId;
/* harmony export (immutable) */ __webpack_exports__["r"] = createOrderComment;
/* harmony export (immutable) */ __webpack_exports__["_13"] = finishOrder;
/* harmony export (immutable) */ __webpack_exports__["C"] = findAttentionListByAccountId;
/* harmony export (immutable) */ __webpack_exports__["l"] = createAttentionGoods;
/* harmony export (immutable) */ __webpack_exports__["B"] = findAccountShareListByAccountId;
/* harmony export (immutable) */ __webpack_exports__["J"] = findCardInfo;
/* harmony export (immutable) */ __webpack_exports__["A"] = findAccountFavoriteList;
/* harmony export (immutable) */ __webpack_exports__["M"] = findLongDetailByLongId;
/* harmony export (immutable) */ __webpack_exports__["F"] = findBrandLiveList;
/* harmony export (immutable) */ __webpack_exports__["O"] = findMonitorList;
/* harmony export (immutable) */ __webpack_exports__["_0"] = findScanHistories;
/* harmony export (immutable) */ __webpack_exports__["_10"] = findUniqueIdInfo;
/* harmony export (immutable) */ __webpack_exports__["E"] = findBrandInfo;
/* harmony export (immutable) */ __webpack_exports__["_11"] = findUniqueIdIsOpenMessage;
/* harmony export (immutable) */ __webpack_exports__["N"] = findMessageList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_comm_request__ = __webpack_require__("flW4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_urls__ = __webpack_require__("imha");
/*
溯源api
*/



function login() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/login',
    data: data
    // params:{
    //     tracing_code: data.code || localStorage.code
    // }
  });
}

// 腾讯云短信验证码
function smsSender() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/smsSender',
    data: data
  });
}

// 微信登录
function wxLogin() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/wxLogin',
    data: data
  });
}

// 关注的品牌动态
function findUserAttentionBrandTrends() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/account/findUserAttentionBrandTrends',
    data: data
  });
}

// 增加|修改收货地址
function createAccountAddress() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/account/createAccountAddress',
    data: data
  });
}

// /mall/account/findAccountAddressByAddressId
// 查询收货地址
function findAccountAddressByAddressId() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/account/findAccountAddressByAddressId',
    data: data
  });
}

// 删除收货地址
function deleteAccountAddress() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/account/deleteAccountAddress',
    data: data
  });
}

// 切换默认地址
function switchDefaultAccountAddress() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/account/switchDefaultAccountAddress',
    data: data
  });
}

// 省市区
function findDistrict() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findDistrict',
    data: data
  });
}

// 收货地址列表
function findAccountAddressListByAccountId() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/account/findAccountAddressListByAccountId',
    data: data
  });
}

function getDistrict() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'get',
    url: '/admin/brand/getDistrict'
  });
}

// https://user-test.vatrue.com/mall/findStoreByStoreId
//  查询商城
function findStoreByStoreId() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findStoreByStoreId',
    data: data
  });
}

// 门店商品分类列表
function findStoreGoodsCategoryList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findStoreGoodsCategoryList',
    data: data
  });
}

// 商城商品列表
function findStoreGoodsList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findStoreGoodsList',
    data: data
  });
}

// 获取门店下的全部商品
function findStoreGoodsListByStoreId() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findStoreGoodsListByStoreId',
    data: data
  });
}
// https://user-test.vatrue.com/mall/findStoreGoodsListByDirection
// 商品价格排序
function findStoreGoodsListByDirection() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findStoreGoodsListByDirection',
    data: data
  });
}

// /mall/searchStoreGoodsListByKeyword
// 商品搜索
function searchStoreGoodsListByKeyword() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/searchStoreGoodsListByKeyword',
    data: data
  });
}

// 品牌详情及动态
function findBrand() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findBrand',
    data: data
  });
}

//
// 商品详情
function findStoreGoods() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findStoreGoods',
    data: data
  });
}

// 物品详情
function findProductIntroduceListByProductId() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findProductIntroduceListByProductId',
    data: data
  });
}

// 追溯事件类别
function findBrandOriginListByBrandId() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findProductTraceScopeByProductId',
    data: data
  });
}

// 追溯事件类别
function findProductTrace() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findProductTrace',
    data: data
  });
}

// 商品评论
function findOrderCommentList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findOrderCommentList',
    data: data
  });
}

//获取品牌动态列表
function findBrandTrendList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findBrandTrendList',
    data: data
  });
}

// 获取品牌动态详情
function findBrandTrendDetail() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findBrandTrendDetail',
    data: data
  });
}

//获取品牌官方商城商品列表
function findOfficialStoreGoodsList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findOfficialStoreGoodsList',
    data: data
  });
}

//创建加入购物车
function createShoppingCart() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/createShoppingCart',
    data: data
  });
}

//购物车商品列表
function findShoppingCartListByAccountId() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findShoppingCartListByAccountId',
    data: data
  });
}

//购物车商品列表
function findShoppingCartList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findShoppingCartList',
    data: data
  });
}

//关注门店
function attentionStore() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/attentionStore',
    data: data
  });
}

// 关注品牌
function attentionBrand() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/attentionBrand',
    data: data
  });
}

// 更改购物车商品数量
function changeShoppingCartNum() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/changeShoppingCartNum',
    data: data
  });
}

// 清空购物车失效的商品
function clearInvalidShoppingCart() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/clearInvalidShoppingCart',
    data: data
  });
}

// 批量关注商品
function createBatchAttentionGoods() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/createBatchAttentionGoods',
    data: data
  });
}
// 更改购物车中商品规格
function changeShoppingCartGoodsSpec() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/changeShoppingCartGoodsSpec',
    data: data
  });
}
// 删除购物车中的商品
function deleteShoppingCartGoods() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/deleteShoppingCartGoods',
    data: data
  });
}

// 获取用户默认地址
function findDefaultAccountAddress() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    doNotRepeat: true,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/account/findDefaultAccountAddress',
    data: data
  });
}
//获取购物车中选中的商品
function findSelectedGoodsList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findSelectedGoodsList',
    data: data
  });
}

//下单
function createOrder() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/createOrder',
    data: data
  });
}

//全部订单列表
function findOrders() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findOrders',
    data: data
  });
}

//JSAPI支付
function pay() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/pay',
    data: data
  });
}

// 支付宝手机网页支付
function aliWapPay() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/aliWapPay',
    data: data
  });
}

//品牌动态评论
function findBrandTrendByTrendId() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findBrandTrendByTrendId',
    data: data
  });
}

//用户品牌动态收藏
function createAccountBrandTrendFavorite() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/createAccountBrandTrendFavorite',
    data: data
  });
}

// 品牌动态点赞
function createAttentionBrandTrend() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/createBrandTrendZambia',
    data: data
  });
}

// 品牌动态评论点赞
function createBrandTrendCommentZambia() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/createBrandTrendCommentZambia',
    data: data
  });
}

// 品牌动态评论
function createBrandTrendComment() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/createBrandTrendComment',
    data: data
  });
}

// 获取用户名片列表
function findAccountCardList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findAccountCardList',
    data: data
  });
}

// 订单提醒发货
function sendOrderNotice() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/sendOrderNotice',
    data: data
  });
}

//订单详情//
function findOrderDetail() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findOrderDetail',
    data: data
  });
}

// 更新收货地址
function updateOrderAddress() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/updateOrderAddress',
    data: data
  });
}
// 删除订单
function deleteOrderByOrderId() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/deleteOrderByOrderId',
    data: data
  });
}

// 获取物流信息
function findOrderLogisticsInfo() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findOrderLogisticsInfo',
    data: data
  });
}

// 获取融云用户信息
function findRongCloudUser() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findRongCloudUser',
    data: data
  });
}
// 融云聊天列表
function findRongMessageList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findRongMessageList',
    data: data
  });
}

//融云聊天详情记录列表
function findRongMessageDetailList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findRongMessageDetailList',
    data: data
  });
}

// 获取腾讯云临时秘钥
function findTempKeys() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findTempKeys',
    data: data
  });
}

// 申请退款/申请售后
function createRefundOrder() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/createRefundOrder',
    data: data
  });
}

// 填写物流信息
function createOrderAfterLogisticsInfo() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/createOrderAfterLogisticsInfo',
    data: data
  });
}

// 获取订单售后信息
function findOrderAfterInfo() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findOrderAfterInfo',
    data: data
  });
}

// /撤销退款申请
function cancelRefundOrder() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/cancelRefundOrder',
    data: data
  });
}

// /取消订单/
function cancelOrderByOrderId() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/cancelOrderByOrderId',
    data: data
  });
}

// 创建订单评论
function createOrderComment() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/createOrderComment',
    data: data
  });
}

// 确认收货
function finishOrder() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/finishOrder',
    data: data
  });
}

// 确认收货
function findAttentionListByAccountId() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findAttentionListByAccountId',
    data: data
  });
}
// 关注商品
function createAttentionGoods() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/createAttentionGoods',
    data: data
  });
}

// 获取用户分享列表/
function findAccountShareListByAccountId() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findAccountShareListByAccountId',
    data: data
  });
}

// 获取名片详情
function findCardInfo() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findCardInfo',
    data: data
  });
}

// 获取用户收藏列表
function findAccountFavoriteList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findAccountFavoriteList',
    data: data
  });
}

// 获取用户收藏列表
function findLongDetailByLongId() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findLongDetailByLongId',
    data: data
  });
}

// 品牌直播列表
function findBrandLiveList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findBrandLiveList',
    data: data
  });
}

// 品牌监控列表
function findMonitorList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/mall/findMonitorList',
    data: data
  });
}

///  扫码历史
function findScanHistories() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/miniApi/mini/account/findScanHistories',
    data: data
  });
}

// 唯一码信息
function findUniqueIdInfo() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/miniApi/mini/findUniqueIdInfo',
    data: data
  });
}

// 溯源品牌信息
function findBrandInfo() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/miniApi/mini/findBrandInfo',
    data: data
  });
}

/**
 * 查看唯一码是否开启留言
 */
function findUniqueIdIsOpenMessage() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/miniApi/mini/findUniqueIdIsOpenMessage',
    data: data
  });
}

/**
 * 查看唯一码是否开启留言
 */
function findMessageList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_comm_request__["a" /* default */])({
    method: 'post',
    showLoading: false,
    url: __WEBPACK_IMPORTED_MODULE_1__config_urls__["a" /* default */].getBaseUrl() + '/miniApi/mini/findMessageList',
    data: data
  });
}

/***/ }),

/***/ "zM9A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_vux@2.9.4@vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("fRcE");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.9.4@vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var src_components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-d0a389fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.9.4@vux/src/components/confirm/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-confirm"},[_c('x-dialog',{attrs:{"dialog-class":_vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',"mask-transition":_vm.maskTransition,"dialog-transition":_vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[(!!_vm.title)?_c('div',{staticClass:"weui-dialog__hd",class:{'with-no-content': !_vm.showContent}},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),(_vm.showContent)?[(!_vm.showInput)?_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2):_c('div',{staticClass:"vux-prompt"},[(((_vm.getInputAttrs()).type)==='checkbox')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.msg)?_vm._i(_vm.msg,null)>-1:(_vm.msg)},on:{"touchend":_vm.setInputFocus,"change":function($event){var $$a=_vm.msg,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.msg=$$a.concat([$$v]))}else{$$i>-1&&(_vm.msg=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.msg=$$c}}}},'input',_vm.getInputAttrs(),false)):(((_vm.getInputAttrs()).type)==='radio')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"radio"},domProps:{"checked":_vm._q(_vm.msg,null)},on:{"touchend":_vm.setInputFocus,"change":function($event){_vm.msg=null}}},'input',_vm.getInputAttrs(),false)):_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":(_vm.getInputAttrs()).type},domProps:{"value":(_vm.msg)},on:{"touchend":_vm.setInputFocus,"input":function($event){if($event.target.composing){ return; }_vm.msg=$event.target.value}}},'input',_vm.getInputAttrs(),false))])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[(_vm.showCancelButton)?_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_default",attrs:{"href":"javascript:;"},on:{"click":_vm._onCancel}},[_vm._v(_vm._s(_vm.cancelText || '取消'))]):_vm._e(),_vm._v(" "),(_vm.showConfirmButton)?_c('a',{staticClass:"weui-dialog__btn",class:("weui-dialog__btn_" + _vm.confirmType),attrs:{"href":"javascript:;"},on:{"click":_vm._onConfirm}},[_vm._v(_vm._s(_vm.confirmText || '确定'))]):_vm._e()])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _vux_2_9_4_vux_src_components_confirm = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.9.4@vux/src/components/confirm/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("b5lX")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_confirm,
  _vux_2_9_4_vux_src_components_confirm,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var node_modules__vux_2_9_4_vux_src_components_confirm = __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.js